import './buttons.css'
const LocationButton = ({ Location }) => {
    const handleLocationButtonClick = () => {
    /*  navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;*/
        
          
          const mapUrl = `https://www.google.com/maps/search/?api=1&query=${Location.Lat},${Location.Lon}`;
          window.open(mapUrl, '_blank');
      /*  },
        (error) => console.log(error)
      );*/
    };
  
    return (
      <button onClick={handleLocationButtonClick} className="menuItems-btn">
          <img src={process.env.PUBLIC_URL+"/img/location.png"} alt=" WhatsApp"></img>
        ubicación</button>
    );
  };
  
  export default LocationButton;